import { render } from "./PixForm.vue?vue&type=template&id=3f18c823&scoped=true"
import script from "./PixForm.vue?vue&type=script&lang=js"
export * from "./PixForm.vue?vue&type=script&lang=js"

import "./PixForm.vue?vue&type=style&index=0&id=3f18c823&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f18c823"]])

export default __exports__